import { c as _c } from "react/compiler-runtime";
import { secondaryButtonBox } from '@/uiComposites/interactive/callToAction';
import { resetIcon } from '@/uiIcons/resetIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { icon } from '@/uiPrimitives/media/icon';
import { textBlock } from '@/uiPrimitives/typography/text';
import { translateInline } from '@/globals/translate/translateInline';
import { MouseEventHandler } from 'react';
import { unprintable } from '@/uiPrimitives/base/printable.css';
import { viewTransitionName } from '@/uiPrimitives/utility/viewTransitionNames.css';
export const ResetButton = t0 => {
  const $ = _c(5);
  const {
    onClick
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(unprintable, secondaryButtonBox({}), shelf({
      columnGap: "-2 | smaller",
      alignItems: "start"
    }), viewTransitionName({
      viewTransitionName: "decision-tool-reset-button"
    }));
    t2 = <span className={classes(occupy({
      blockSize: "capSize"
    }))}><i className={classes(icon({
        icon: resetIcon,
        blockSize: "5 | betweenParagraphs"
      }))} /></span>;
    t3 = <span className={classes(textBlock({}))}>{translateInline({
        en: "Restart",
        nl: "Start opnieuw"
      })}</span>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClick) {
    t4 = <button onClick={onClick} type="button" className={t1}>{t2}{t3}</button>;
    $[3] = onClick;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};